
import { InitiationStep } from '@/hooks/initiation';

interface DebugPanelProps {
  address: `0x${string}` | undefined;
  currentStep: InitiationStep;
  supabaseReady: boolean;
  hasToken: boolean;
  mobileDetected: boolean;
}

const DebugPanel = ({ 
  address, 
  currentStep, 
  supabaseReady, 
  hasToken, 
  mobileDetected 
}: DebugPanelProps) => {
  return (
    <div className="mb-6 p-3 bg-navy-dark rounded-md text-sm">
      <p className="text-gray-300">Wallet: {address || 'Not Connected'}</p>
      <p className="text-gray-300">State: {InitiationStep[currentStep]}</p>
      <p className="text-gray-300">Supabase: {supabaseReady ? '✅ Connected' : '❌ Not Connected'}</p>
      <p className="text-gray-300">Token: {hasToken ? '✅ Has Token' : '❌ No Token'}</p>
      <p className="text-gray-300">Mobile: {mobileDetected ? '📱 Yes' : '💻 No'}</p>
    </div>
  );
};

export default DebugPanel;
